export const RECENTLY_SELECTED_GREENVOUCHER_VALUE = 'recentlySelectedGreenVoucherValue';
export const RECENTLY_SELECTED_GREENVOUCHER_NUMBER = 'recentlySelectedGreenVoucherNumber';
export const MAIN_PRODUCT_STATE_SNAPSHOT = 'mainProductStateSnapshot';
export const ESIM_TOKEN = 'esimToken';
export const EID_SHOW_MSISDN_CAPTCHA = 'eidShowMsisdnCaptcha';
export const EID_SHOW_CODE_CAPTCHA = 'eidShowCodeCaptcha';
export const EID_REGISTRATION_MSISDN = 'eidRegistrationMsisdn';
export const EID_REGISTRATION_MSISDN_VERIFIED = 'eidRegistrationMsisdnVerified';

